import type { FigmaIconProps } from './types';

export const IconFigmaLockRounded = ({ size = 16, color = 'currentColor' }: FigmaIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.5833 11.9167H5.41667C4.22005 11.9167 3.25 12.8867 3.25 14.0833V21.6667C3.25 22.8633 4.22005 23.8333 5.41667 23.8333H20.5833C21.78 23.8333 22.75 22.8633 22.75 21.6667V14.0833C22.75 12.8867 21.78 11.9167 20.5833 11.9167Z"
      stroke={color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.58333 11.9167V7.58333C7.58333 6.14674 8.15402 4.76899 9.16984 3.75317C10.1857 2.73735 11.5634 2.16667 13 2.16667C14.4366 2.16667 15.8143 2.73735 16.8302 3.75317C17.846 4.76899 18.4167 6.14674 18.4167 7.58333V11.9167"
      stroke={color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
